export interface Asignatura {
    id?: string,
    nombre: string,
    descripcion: string
}

export const defaultAsignatura = { id: '', nombre: '', descripcion: '' };